import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import {
  adminApprovalEvaluateTracesType,
  adminApprovalEvaluateTracesQueryArgs,
  AdminApprovalEvaluateTracesByFiltersQueryArgs,
  AdminApprovalEvaluateTracesQueryArgs,
  adminApprovalEvaluateTracesByFiltersQueryArgs
} from '../types/admin-approval-evaluate-traces'
import { mapVulnerabilityFilters } from '../endpoint-helpers/vulnerabilities'

export const adminApprovalEvaluateTraces: GraphQLFieldConfig<
  any,
  Context,
  AdminApprovalEvaluateTracesQueryArgs
> = {
  description:
    'Determine if a set of vulnerabilities is a candidate for approval workflow',
  type: new GraphQLNonNull(adminApprovalEvaluateTracesType),
  args: adminApprovalEvaluateTracesQueryArgs,
  async resolve(
    _source,
    args,
    context
  ): Promise<{
    readonly result: boolean
  }> {
    const { input } = args
    if (!input) {
      throw new Error('query input parameter is required')
    }
    const { connector } = context
    const { organizationID, traces, status } = input
    const resp = await connector.post(
      `/${organizationID}/approval-workflow/traces/evaluate`,
      {
        traces,
        status
      }
    )

    return resp
  }
}

export const adminApprovalEvaluateTracesByFilters: GraphQLFieldConfig<
  any,
  Context,
  AdminApprovalEvaluateTracesByFiltersQueryArgs
> = {
  description:
    'Determine if a set of vulnerabilities, specified by filters, is a candidate for approval workflow',
  type: new GraphQLNonNull(adminApprovalEvaluateTracesType),
  args: adminApprovalEvaluateTracesByFiltersQueryArgs,
  async resolve(
    _source,
    args,
    context
  ): Promise<{
    readonly result: boolean
  }> {
    const { input } = args
    if (!input) {
      throw new Error('query input parameter is required')
    }
    const { connector } = context
    const { organizationID, filters, status } = input
    const resp = await connector.post(
      `/${organizationID}/approval-workflow/traces/evaluate/filters`,
      {
        filters: mapVulnerabilityFilters(filters),
        status
      }
    )

    return resp
  }
}
